/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Component, Input, OnInit } from '@angular/core';
import { Logger } from '@app/core';
import { Night } from '@app/hotels/rooms/night.model';

const log = new Logger('NightStatusComponent');

@Component({
  selector: 'app-night-status',
  templateUrl: './night-status.component.html',
  styleUrls: ['./night-status.component.scss'],
})
export class NightStatusComponent implements OnInit {
  @Input() night: Night;
  status: string;

  constructor() {}

  ngOnInit() {
    if (!this.night) {
      log.warn('Night not found or not loaded yet.');
    }
    if (this.night.sold_price > 0) {
      this.status = 'sold'; // Венко каза така на 15.01.2020
    } else if (this.night.hotel_booking_cancellation_id) {
      this.status = 'cancelled';
    } else if ((this.night.sold_price <= 0 || !this.night.sold_price) && !this.night.hotel_booking_cancellation_id) {
      this.status = 'available';
    } else {
      this.status = 'ERROR';
      log.error('Something wrong with night status');
    }
  }
}
